<template>
  <main class="main customer_manual" role="main">
    <div class="main_con">
      <div class="manual_tab">
        <div
          class="tab_btn pnt"
          :class="{ on: isTab == 'tab_2' }"
          @click="manual_tab_sel('tab_2')"
        >
          인터넷 가입
        </div>
        <div
          class="tab_btn pnt"
          :class="{ on: isTab == 'tab_1' }"
          @click="manual_tab_sel('tab_1')"
        >
          휴대폰 구매
        </div>
      </div>
      <div class="sub_txt" v-if="isTab == 'tab_2'">
        퍼스에서 인터넷 견적 받기를 시작하는 방법에는<br />두 가지가 있어요!
      </div>
      <div class="sub_txt" v-else-if="isTab == 'tab_1'">
        퍼스에서 휴대폰 견적 받기를 시작하는 방법에는<br />두 가지가 있어요!
      </div>
      <div class="list_bar"></div>
      <div class="method_perce" v-if="isTab == 'tab_2'">
        <ul class="tuto_list">
          <li>
            <div class="list_top_wrap">
              <div class="step"><p>첫번째 방법</p></div>
              <div class="link" @click="goLink('InternetCommerce.Main')">
                <div class="link_txt">바로가기</div>
                <div class="link_img">
                  <img
                    :src="
                      require('@/assets/front/images/new/ar_hash_down_g.svg')
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="txt_1">
              <p>
                다양한 상품의 견적을 받아보고 싶어요!
              </p>
            </div>
            <div class="way_img_wrap">
              <div class="way_img_list">
                <div
                  class="list_wrap"
                  v-for="(item, index) in internet_manual_1"
                  :key="index"
                >
                  <div class="way_img">
                    <img
                      :src="
                        require(`@/assets/front/images/v2/manual/${item.img}`)
                      "
                      alt=""
                    />
                  </div>
                  <div class="way_txt">
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="list_bar"></div>
        <ul class="tuto_list">
          <li>
            <div class="list_top_wrap">
              <div class="step"><p>두번째 방법</p></div>
              <div class="link" @click="goLink('InternetCommerce.Main')">
                <div class="link_txt">바로가기</div>
                <div class="link_img">
                  <img
                    :src="
                      require('@/assets/front/images/new/ar_hash_down_g.svg')
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="txt_1">
              <p>
                나에게 맞는 상품을 추천 받고 싶어요!
              </p>
            </div>
            <div class="way_img_wrap">
              <div class="way_img_list">
                <div
                  class="list_wrap"
                  v-for="(item, index) in internet_manual_2"
                  :key="index"
                >
                  <div class="way_img">
                    <img
                      :src="
                        require(`@/assets/front/images/v2/manual/${item.img}`)
                      "
                      alt=""
                    />
                  </div>
                  <div class="way_txt">
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="list_bar"></div>
      </div>
      <div class="method_perce" v-if="isTab == 'tab_1'">
        <ul class="tuto_list">
          <li>
            <div class="list_top_wrap">
              <div class="step"><p>첫번째 방법</p></div>
              <div class="link" @click="goLink('Mobile.Main')">
                <div class="link_txt">바로가기</div>
                <div class="link_img">
                  <img
                    :src="
                      require('@/assets/front/images/new/ar_hash_down_g.svg')
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="txt_1">
              <p>
                구매를 원하는 휴대폰이 있어요!
              </p>
            </div>
            <div class="way_img_wrap">
              <div class="way_img_list">
                <div
                  class="list_wrap"
                  v-for="(item, index) in mobile_manual_1"
                  :key="index"
                >
                  <div class="way_img">
                    <img
                      :src="
                        require(`@/assets/front/images/v2/manual/${item.img}`)
                      "
                      alt=""
                    />
                  </div>
                  <div class="way_txt">
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="list_bar"></div>
        <ul class="tuto_list">
          <li>
            <div class="list_top_wrap">
              <div class="step"><p>두번째 방법</p></div>
              <div class="link" @click="goLink('Mobile.Main')">
                <div class="link_txt">바로가기</div>
                <div class="link_img">
                  <img
                    :src="
                      require('@/assets/front/images/new/ar_hash_down_g.svg')
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="txt_1">
              <p>
                어떤걸 사야할지 못 정했지만 휴대폰에 원하는 스펙이 있어요!
              </p>
            </div>
            <div class="way_img_wrap">
              <div class="way_img_list">
                <div
                  class="list_wrap"
                  v-for="(item, index) in mobile_manual_2"
                  :key="index"
                >
                  <div class="way_img">
                    <img
                      :src="
                        require(`@/assets/front/images/v2/manual/${item.img}`)
                      "
                      alt=""
                    />
                  </div>
                  <div class="way_txt">
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="list_bar"></div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  components: {},
  name: '',
  computed: {},
  created() {},
  data() {
    return {
      isTab: this.$route.params.isTab || 'tab_2',
      internet_manual_1: [
        {
          img: 'tuto_internet_way_01_01.png',
          content:
            '인터넷 메인 화면의<br />‘바로 견적 요청하기’ 버튼으로 시작!',
        },
        {
          img: 'tuto_internet_way_01_02.png',
          content: '간편하게 개통 희망하는 사양을 등록해주세요.',
        },
        {
          img: 'tuto_internet_way_01_03.png',
          content:
            '등록하신 견적 정보는 전국 매장에 공개되며,<br />다양한 견적을 받아 보실 수 있습니다.',
        },
        {
          img: 'tuto_internet_way_01_04.png',
          content:
            '매장들에게 받은 견적의 정보와<br />매장리뷰 등을 참고하여 꼼꼼히 비교해주세요.',
        },
        {
          img: 'tuto_internet_way_01_05.png',
          content:
            '받은 견적 중 마음에 드는 2~3곳을 선정해<br />채팅상담을 진행해 보세요.',
        },
        {
          img: 'tuto_internet_way_01_06.png',
          content:
            '매장과 계약을 하기로 했으면 ‘가입 신청서’를<br />요청하여 작성 후 전달하면 완료! <span class="rd">(필수)</span>',
        },
      ],
      internet_manual_2: [
        {
          img: 'tuto_internet_way_02_01.png',
          content:
            '인터넷 메인 화면 스크롤 후<br />‘나에게 맞는 인터넷, TV’의 필터를 터치하기!',
        },
        {
          img: 'tuto_internet_way_02_02.png',
          content: '원하시는 인터넷 필터를 설정해 주세요.',
        },
        {
          img: 'tuto_internet_way_02_03.png',
          content: '필터 결과로 나온 상품들 중<br />마음에 드는 상품을 터치!',
        },
        {
          img: 'tuto_internet_way_02_04.png',
          content:
            '상품설명을 꼼꼼히 읽고 결정하셨다면<br />견적 받아보기 버튼을 눌러주세요.',
        },
        {
          img: 'tuto_internet_way_02_05.png',
          content: '상품정보 외 필요한 개통 정보를 등록해주세요.',
        },
        {
          img: 'tuto_internet_way_02_06.png',
          content:
            '등록하신 견적 정보는 전국 매장에 공개되며,<br />다양한 견적을 받아 보실 수 있습니다.',
        },
        {
          img: 'tuto_internet_way_02_07.png',
          content:
            '매장들에게 받은 견적의 정보와<br />매장리뷰 등을 참고하여 꼼꼼히 비교해주세요.',
        },
        {
          img: 'tuto_internet_way_02_08.png',
          content:
            '받은 견적 중 마음에 드는 2~3곳을 선정해<br />채팅상담을 진행해 보세요.',
        },
        {
          img: 'tuto_internet_way_02_09.png',
          content:
            '매장과 계약을 하기로 했으면 ‘가입 신청서’를<br />요청하여 작성 후 전달하면 완료! <span class="rd">(필수)</span>',
        },
      ],
      mobile_manual_1: [
        {
          img: 'tuto_mobile_way_01_01.png',
          content:
            '휴대폰 메인 화면의 휴대폰 탭을 클릭 후<br />‘휴대폰 견적 받아보기’ 버튼으로 시작!',
        },
        {
          img: 'tuto_mobile_way_01_02.png',
          content: '간편하게 개통 희망하는 사양을 등록해주세요.',
        },
        {
          img: 'tuto_mobile_way_01_03.png',
          content:
            '등록하신 견적 정보는 전국 매장에 공개되며,<br />다양한 견적을 받아 보실 수 있습니다.',
        },
        {
          img: 'tuto_mobile_way_01_04.png',
          content:
            '매장들에게 받은 견적의 정보와<br />매장리뷰 등을 참고하여 꼼꼼히 비교해주세요.',
        },
        {
          img: 'tuto_mobile_way_01_05.png',
          content:
            '받은 견적 중 마음에 드는 2~3곳을 선정해<br />채팅상담을 진행해 보세요.',
        },
        {
          img: 'tuto_mobile_way_01_06.png',
          content:
            '매장과 계약을 하기로 했으면<br />‘방문 약속’을 해주세요! <span class="rd">(필수)</span>',
        },
        {
          img: 'tuto_mobile_way_01_07.png',
          content:
            '퍼스 외부에서의 대화를 유도하는 매장과는<br />계약 금지! <span class="rd">분쟁시 퍼스의 도움을 받을 수 없습니다.</span>',
        },
      ],
      mobile_manual_2: [
        {
          img: 'tuto_mobile_way_02_01.png',
          content:
            '휴대폰 메인 화면 휴대폰 탭에서 스크롤을 내리면<br />보이는 휴대폰 찾기 필터를 터치!',
        },
        {
          img: 'tuto_mobile_way_02_02.png',
          content: '원하시는 휴대폰 필터를 설정해 주세요.',
        },
        {
          img: 'tuto_mobile_way_02_03.png',
          content:
            '필터 결과로 나온 상품들 중<br />마음에 드는 상품이 있다면 견적받기 버튼 터치!',
        },
        {
          img: 'tuto_mobile_way_02_04.png',
          content: '간편하게 개통 희망하는 사양을 등록해주세요.',
        },
        {
          img: 'tuto_mobile_way_02_05.png',
          content:
            '등록하신 견적 정보는 우리 동네 매장에 공개되며,<br />다양한 견적을 받아 보실 수 있습니다.',
        },
        {
          img: 'tuto_mobile_way_02_06.png',
          content:
            '매장들에게 받은 견적의 정보와<br />매장리뷰 등을 참고하여 꼼꼼히 비교해주세요.',
        },
        {
          img: 'tuto_mobile_way_02_07.png',
          content:
            '받은 견적 중 마음에 드는 2~3곳을 선정해<br />채팅상담을 진행해 보세요.',
        },
        {
          img: 'tuto_mobile_way_02_08.png',
          content:
            '매장과 계약을 하기로 했으면<br />‘방문 약속’을 해주세요! <span class="rd">(필수)</span>',
        },
        {
          img: 'tuto_mobile_way_02_09.png',
          content:
            '퍼스 외부에서의 대화를 유도하는 매장과는<br />계약 금지! <span class="rd">분쟁시 퍼스의 도움을 받을 수 없습니다.</span>',
        },
      ],
    };
  },
  async mounted() {},
  methods: {
    manual_tab_sel(sel) {
      this.isTab = sel;
    },
    goMain(tab, sec) {
      this.$router.push({
        name: 'Home',
        params: { isTab: tab, isSec: sec },
      });
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
  },
};
</script>
